<template>

  <NavBar/>
 
  <router-view/>

<PageFooter/>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import PageFooter from './components/PageFooter.vue';

export default {
  components: {
    NavBar,
    PageFooter
  }
}


</script>

<style>


:root {
    --primary: #79ac33;
    --app-height: 100%;
  }

  html,body,#app {
    height:100%;
  }

  .white-muted {
    color:rgba(255, 255, 255, 0.60);
  }

  .no-select {
    user-select: none;
  }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display:flex;
  flex-direction: column;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
